/**
 * Step 1) Define user activities
 * 1.Optional.Load for search menu:: roles(Not supported), status (HardCode):: onload && success && RESET(Should have)
 * 2.Search action (FILTER| FILTER_SUCCESS | FILTER_FAILED)
 * 3.Edit User Info --> Need to load roles info
 * 4.Create Roles info :: (Optional verify user exist by email???)
 * 5.Force To reload??
 * 
 */

 export const USER_MNGT_ONLOAD = 'userMngt/onLoad';
 export const userMngtOnload = () => ({
   type: USER_MNGT_ONLOAD
 });


 export const USER_MNGT_ONLOAD_SUCCESS = 'userMngt/onLoadSuccess';
 export const userMngtOnloadSuccess = (data) => ({
   type: USER_MNGT_ONLOAD_SUCCESS,
   payload: data
 });

 export const USER_MNGT_ONLOAD_FAILED = 'userMngt/onLoadFailed';
 export const userMngtOnloadFailed = (error) => ({
   type: USER_MNGT_ONLOAD_FAILED,
   payload: error
 });

export const USER_SEARCH_RESET = 'userMngt/reset';
export const userSearchReset = () => ({
  type: USER_SEARCH_RESET
});


export const USER_SEARCH = 'userMngt/search';
export const userSearchByCriteria = searchCriteria => ({
  type: USER_SEARCH,
  payload: searchCriteria
});


export const USER_SEARCH_SUCCESSFUL = 'userMngt/search_on_success';
export const userSearchSuccessful = userPagingnation => ({
  type: USER_SEARCH_SUCCESSFUL,
  payload: userPagingnation
});

export const USER_SEARCH_FAILED = 'userMngt/search_on_failed';
export const userSearchFailed = error => ({
  type: USER_SEARCH_FAILED,
  payload: error
});

export const CE_USER_ONLOAD = 'userMngt/ceUserOnLoad';
export const ceUserOnload = () => ({
  type: CE_USER_ONLOAD
});

export const CE_USER_ONLOAD_SUCCESS = 'userMngt/ceUserOnLoadSuccess';
export const ceUserOnLoadSuccess = (data) => ({
  type: CE_USER_ONLOAD_SUCCESS,
  payload: data
});

export const CE_USER = 'userMngt/ceUser';
export const ceUser = (data) => ({
  type: CE_USER,
  payload: data
});

export const CE_USER_SUCCESS = 'userMngt/ceUserSuccess';
export const ceUserSuccess = (data) => ({
  type: CE_USER_SUCCESS,
  payload: data
});

export const CE_USER_FAILED = 'userMngt/ceUserFailed';
export const ceUserFailed = error => ({
  type: CE_USER_FAILED,
  payload: error
});

export const CE_USER_ON_RESET = 'userMngt/ceUserReset';
export const ceUserOnReset = () => ({
  type: CE_USER_ON_RESET
});
